import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/application_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  desc_cont: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.desc',
  },
  name_cont: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.name',
  },
  share_desc_cont: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.shareDesc',
  },
  share_title_cont: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.shareTitle',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Application', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Application', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
